export default "__VITE_ASSET__f032f188__"